import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PilotShare } from "./PilotShare";
import { useLang } from "../../i18n/LanguageContext";

export const PilotBand = () => {
  const { t } = useLang();
  const p = t.pilot;
  return (
    <section className="relative bg-ink bp-grid-dark border-y border-[#f8f7f4]/10 py-16 sm:py-20" data-testid="pilot-band">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <div>
            <Reveal>
              <p className="font-mono-tech text-[0.7rem] tracking-[0.28em] uppercase text-[#e63946]" data-testid="pilot-band-eyebrow">
                {p.eyebrow}
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-3 font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-[#f8f7f4]" data-testid="pilot-band-title">
                {p.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <Link
              to="/partners"
              data-testid="pilot-band-cta"
              className="chamfer-sm shrink-0 inline-flex items-center gap-2 border border-[#f8f7f4]/25 px-5 py-3 font-mono-tech text-[11px] font-semibold uppercase tracking-[0.15em] text-[#f8f7f4]/80 transition-colors duration-200 hover:border-[#e63946] hover:text-[#f8f7f4]"
            >
              {p.cta}
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-px bg-[#f8f7f4]/10 border border-[#f8f7f4]/10">
          {p.stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.05} className="bg-ink p-5">
              <div className="font-display text-xl sm:text-2xl font-black tracking-tight text-[#f8f7f4]" data-testid={`pilot-band-stat-${i}`}>
                {s.val}
              </div>
              <div className="mt-1 font-mono-tech text-[9px] uppercase tracking-[0.15em] text-[#f8f7f4]/45">{s.label}</div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-5 max-w-4xl text-xs sm:text-sm leading-relaxed text-[#f8f7f4]/55" data-testid="pilot-band-note">{p.note}</p>
        </Reveal>
        <PilotShare />
      </div>
    </section>
  );
};
